<template>
  <span @click="showConfirm">
    <slot />
  </span>
</template>

<script lang="ts">
import { createVNode, defineComponent } from 'vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { app } from '@/libs/app';
import { Modal } from 'ant-design-vue';
import './styles.scss';

app.use(Modal);

export default defineComponent({
  name: 'ModalConfirm',
  props: {
    dynamicAttrs: {},
    ok: Function,
    cancel: Function,
    visible: Boolean,
    title: String,
    content: String,
    okText: {
      type: String,
      default: 'Yes',
    },
    cancelText: {
      type: String,
      default: 'No',
    },
  },
  setup(props) {
    const showConfirm = () => {
      Modal.confirm({
        maskClosable: true,
        title: props.title,
        icon: createVNode(ExclamationCircleOutlined),
        content: props.content,
        okText: props.okText,
        cancelText: props.cancelText,
        onOk() {
          if (props.ok) props.ok();
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onCancel() { if (props.cancel) props.cancel(); },
      });
    };
    return {
      showConfirm,
    };
  },
});
</script>
